import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { exchangeSession } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    exchangeSession(sessionId)
      .then((user) => {
        // Clear the fragment from URL and go to portal
        window.history.replaceState({}, document.title, "/portal");
        navigate("/portal", { replace: true, state: { user } });
      })
      .catch(() => {
        navigate("/login", { replace: true });
      });
  }, [navigate]);

  return (
    <div data-testid="auth-callback" className="min-h-screen bg-canvas flex items-center justify-center">
      <div className="text-center">
        <Loader2 size={32} className="text-ochre animate-spin mx-auto" />
        <p className="text-muted2 mt-4 text-sm">Signing you in…</p>
      </div>
    </div>
  );
}
